import React, { forwardRef, useEffect, useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import SmallSpinner from './SmallSpinner';

interface ClearableFormControlProps {
    type: string;
    placeholder?: string;
    id: string;
    className?: string;
    value: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    isLoading: boolean;
}

const ClearableFormControl = forwardRef<HTMLInputElement, ClearableFormControlProps>(({
    type, placeholder, id, className, value, onChange, isLoading
}: ClearableFormControlProps, ref) => {
    const [spinnerVisible, setSpinnerVisible] = useState<boolean>(false);

    const clear = () => {
        onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
    };

    useEffect(() => {
        setSpinnerVisible(true);
    }, [value]);

    useEffect(() => {
        if (!isLoading) {
            setSpinnerVisible(false);
        }
    }, [isLoading]);

    return (
        <InputGroup className={className} style={{ position: 'relative', zIndex: 0 }}>
            <Form.Control
                ref={ref}
                type={type}
                placeholder={placeholder}
                id={id}
                value={value}
                onChange={onChange}
                style={{ paddingRight: '30px', zIndex: 1 }}
            />
            {
                spinnerVisible ?
                    <SmallSpinner /> :
                    value &&
                        <Button
                            variant='link'
                            onClick={clear}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                padding: 0,
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <FaTimes style={{ color: 'grey', fontSize: '120%' }} />
                        </Button>
            }
        </InputGroup>
    );
});

export default ClearableFormControl;
